<template>
  <div class="plot-assignment-component" v-if="plot.early_bird_form === undefined || plot.early_bird_form === null">
    <div v-if="plot.build && plot.build.user">
      <span class="me-2"><strong>Assigned To</strong>: {{ plot.build.user.name }} - {{ plot.build.user.email }}</span>
      <a :href="`/admin/users/${plot.build.user_id}/edit`"
         class="btn btn-sm btn-info me-2">View</a>
      <button @click="deassignPlot(plot)" type="button" class="btn btn-sm btn-danger">De-Assign</button>

      <span v-if="plot.build.reservation_form" class="d-block">
                <strong>Reservation Form</strong>:
                {{ plot.build.reservation_form.status }}
                <a :href="`/admin/users/${plot.build.user_id}/forms/reservation-form`"
                   class="ms-2 btn btn-sm btn-secondary"
                >View Reservation Form</a>
              </span>
    </div>
    <div v-else>
      <div v-if="showPlotAssign" class="row">
        <div class="col-12">
          <user-select-component :create-input="false" user-type="customer"
                                 v-on:user-selected="(user) => plotUserSelected(plot, user)"></user-select-component>
        </div>
      </div>

      <button
        @click="togglePlotAssign"
        v-if="!showPlotAssign"
        type="button"
        class="btn btn-sm btn-info"
      >
        Show House Assigment
      </button>

      <button
        @click="assignPlot(plot)"
        v-else
        type="button"
        class="btn btn-sm btn-success"
      >
        Assign House
      </button>

      <button
        v-if="showPlotAssign"
        @click="showPlotAssign = false"
        type="button"
        class="btn btn-sm btn-danger"
      >
        Close House Assignment
      </button>
    </div>
  </div>
</template>

<script>
import UserSelectComponent from "./UserSelectComponent.vue";

export default {
  name: "PlotAssignmentComponent",

  components: {
    UserSelectComponent,
  },

  props: {
    plot: {
      type: Object,
      required: true
    },

    developmentId: {
      type: Number,
      required: true
    },
  },

  data() {
    return {
      showPlotAssign: false,
      confirmed: false,
    }
  },

  methods: {
    togglePlotAssign() {
      this.showPlotAssign = !this.showPlotAssign;
    },

    assignPlot(plot) {
      if (this.showPlotAssign) {

        if (!plot.user_to_assign) {
          return this.showPlotAssign = false;
        }

        this.loading = true;

        return axios
          .post(
            `${window.api_url}/admin/developments/assign_plot/${this.developmentId}`,
            {
              plot_id: plot.id,
              user_id: plot.user_to_assign,
              confirmed: this.confirmed,
            }
          )
          .then(response => {
            this.loading = false;

            if (response.data.success) {
              if (response.data.needs_confirmation) {
                const user = response.data.user;
                const currentDevelopment = response.data.user.build && response.data.user.build.development_house_type ? response.data.user.build.development_house_type.development : null;
                const currentHouseType = response.data.user.build && response.data.user.build.development_house_type ? response.data.user.build.development_house_type.house_type : null;
                const currentPlot = response.data.user.build && response.data.user.build.plot ? response.data.user.build.plot : null;

                let message = `Are you sure you want to assign ${user.name}?`;

                if (currentDevelopment && currentHouseType) {
                  message += `\n\n${user.name} is a currently assigned to ${currentDevelopment.name} - ${currentHouseType.name}.`;
                }

                if (currentPlot) {
                  message += `\n\nPlot reference: ${currentPlot.reference}.`;
                }

                this.confirmed = confirm(message);

                if (this.confirmed) {
                  return this.assignPlot(plot);
                }

                return false;
              }

              plot.user_to_assign = null;
              notyf.success(`Plot ${plot.name_number} has been successfully assigned.`);

              this.$emit('plots-updated', response.data.plots);

              if (this.$parent.$el.id === 'app') {
                this.plot = response.data.plots.find(p => p.id === this.plot.id);
              }
            } else {
              notyf.error(`Something went wrong, please try again.`);
            }
          })
          .catch(error => {
            this.loading = false;
            notyf.error(`Something went wrong, please try again.`);
          })
          .finally(() => {
            this.confirmed = false;
          });
      } else {
        return this.showPlotAssign = true;
      }
    },

    deassignPlot(plot) {
      this.loading = true;

      axios.post(`${window.api_url}/admin/developments/deassign_plot/${this.developmentId}`, {
        plot_id: plot.id,
      })
        .then(response => {
          this.loading = false;
          notyf.success(`Plot ${plot.name_number} has been successfully de-assigned.`);

          this.$emit('plots-updated', response.data.plots);
          Livewire.emit('deassignedPlot')

          if (this.$parent.$el.id === 'app') {
            this.plot = response.data.plots.find(p => p.id === this.plot.id);
          }
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
          notyf.success(`Something went wrong, please try again.`);
        });
    },

    plotUserSelected(plot, user) {
      plot.user_to_assign = user.id;
      console.log(plot.user_to_assign);
    },
  },
}
</script>

<style scoped lang="scss">

</style>
